module.exports = __webpack_public_path__ + "static/desktop-thanks-for-visiting-img-988edeeecf036143b7799028eea56107.png";